module.exports = __webpack_public_path__ + "img/autobus-breton.5cdc306b.png";